module.exports = __webpack_public_path__ + "static/media/image_new.d8e5e3e8.png";